import Tooltip from 'components/Tooltip'
import { useRef, useState } from 'react'
import { Badge, Overlay } from 'react-bootstrap'
import cn from 'classnames'
import s from './TooltipBadge.module.scss'

interface Props {
  label: string
  tooltip?: JSX.Element
  className?: string
}

const defaultProps = {
  className: undefined,
  tooltip: undefined,
}

const releaseToggleV2 = process?.env?.REACT_APP_RELEASE_TOGGLE_V2 === 'true'

const TooltipBadge = ({ label, tooltip, className }: Props): JSX.Element => {
  const [show, setShow] = useState(false)
  const target = useRef(null)

  return (
    <>
      <Badge
        data-testid="tooltip-badge"
        bg="none"
        className={cn(releaseToggleV2 ? s.badgeIconV2 : s.badge, className)}
        ref={target}
        pill
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        i
      </Badge>

      {tooltip && (
        <Overlay target={target.current} show={show} placement="right">
          <Tooltip id={`${label}-tooltip`}>{tooltip}</Tooltip>
        </Overlay>
      )}
    </>
  )
}

TooltipBadge.defaultProps = defaultProps
export default TooltipBadge
